export default __webpack_public_path__ + "static/media/icon-linkedin.d17d4cf4.svg";